import { Autocomplete, TextField } from '@mui/material';
import React, { useCallback, useMemo } from 'react';
import { IContentFieldProps, IOption } from 'types/fields';

interface IIdPInputMultiFieldProps extends IContentFieldProps {
	options: string[] | IOption[];
	limitToOptions: boolean;
	preventChars: string | undefined;
	noOptionsText: string | undefined;
	placeholder?: string | undefined;
}

const IdPInputMultiField: React.FC<IIdPInputMultiFieldProps> = ({
	disabled,
	displayName,
	name,
	onChange,
	required,
	value,
	options,
	limitToOptions,
	preventChars,
	noOptionsText,
	placeholder = undefined,
	error
}) => {
	const handleChange = useCallback(
		(e: any, newValue: string[]) => {
			onChange(newValue);
		},
		[onChange]
	);

	const optionsValues = useMemo(
		() =>
			options.map((option) =>
				typeof option === 'string' ? option : option.value
			),
		[options]
	);

	const renderOption = useCallback(
		(props: any, optionValue: string) => {
			const { key, ...restProps } = props;
			if (!options[0] || typeof options[0] === 'string') {
				return (
					<li key={key} {...restProps}>
						{optionValue}
					</li>
				);
			}
			return (
				<li key={key} {...restProps}>
					{intl.tr(
						(options as IOption[]).find(
							(option) => option.value === optionValue
						)!.label
					)}
				</li>
			);
		},
		[options]
	);
	return (
		<Autocomplete
			data-testid="field-multi"
			size="small"
			disabled={disabled}
			options={optionsValues}
			renderOption={renderOption}
			value={value as string[]}
			onChange={handleChange}
			freeSolo={!limitToOptions}
			multiple
			autoSelect
			noOptionsText={noOptionsText}
			slotProps={{
				popper: {
					'data-testid': 'autocomplete-popper'
				} as any
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					placeholder={placeholder}
					slotProps={{
						inputLabel: { shrink: true }
					}}
					name={name}
					required={required}
					label={displayName}
					onKeyDown={(e) => {
						/* istanbul ignore next: could not test this */
						if (preventChars && preventChars.includes(e.key)) {
							/* istanbul ignore next: could not test this */
							e.preventDefault();
						}
					}}
					error={Boolean(error)}
					helperText={error}
				/>
			)}
		/>
	);
};

export default IdPInputMultiField;
